var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 241,
    viewBox: "0 0 240 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1564_105130)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.8457,
    y: 60.6182,
    width: 162.307,
    height: 119.615,
    rx: 24.4571,
    fill: "url(#paint0_linear_1564_105130)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.6128 158.583C74.2439 158.583 77.1876 155.639 77.1876 152.008C77.1876 148.377 74.2439 145.434 70.6128 145.434C66.9817 145.434 64.0381 148.377 64.0381 152.008C64.0381 155.639 66.9817 158.583 70.6128 158.583ZM91.7394 145.434C88.1083 145.434 85.1646 148.377 85.1646 152.008C85.1646 155.639 88.1083 158.583 91.7394 158.583L120.41 158.583C124.041 158.583 126.985 155.639 126.985 152.008C126.985 148.377 124.041 145.434 120.41 145.434L91.7394 145.434Z",
    fill: "url(#paint1_linear_1564_105130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.2236,
    y: 91.6504,
    width: 164.439,
    height: 22.5324,
    fill: "url(#paint2_linear_1564_105130)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M185.177 137.819C188.872 131.419 198.11 131.419 201.805 137.819L236.234 197.452C239.929 203.852 235.31 211.852 227.92 211.852H159.062C151.672 211.852 147.053 203.852 150.748 197.452L185.177 137.819Z",
    fill: "url(#paint3_linear_1564_105130)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192.895 189.54L193.519 189.506L194.093 189.54C195.286 189.682 196.386 190.257 197.183 191.155C197.981 192.053 198.422 193.213 198.422 194.415C198.422 195.616 197.981 196.776 197.183 197.674C196.386 198.572 195.286 199.147 194.093 199.289L193.47 199.323L192.895 199.289C191.702 199.147 190.603 198.572 189.805 197.674C189.007 196.776 188.567 195.616 188.567 194.415C188.567 193.213 189.007 192.053 189.805 191.155C190.603 190.257 191.702 189.682 192.895 189.54Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M190.209 156.387C191.107 155.588 192.267 155.146 193.47 155.146C194.672 155.146 195.832 155.588 196.731 156.387C197.629 157.186 198.203 158.286 198.344 159.48L198.378 160.055V179.689L198.344 180.263C198.202 181.456 197.627 182.556 196.729 183.354C195.831 184.151 194.671 184.592 193.47 184.592C192.268 184.592 191.109 184.151 190.21 183.354C189.312 182.556 188.737 181.456 188.596 180.263L188.561 179.689V160.055L188.596 159.48C188.736 158.286 189.31 157.186 190.209 156.387Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.536 189.224L194.127 189.26C195.388 189.41 196.551 190.018 197.395 190.968C198.238 191.918 198.704 193.144 198.704 194.415C198.704 195.685 198.238 196.912 197.395 197.862C196.551 198.812 195.388 199.419 194.126 199.569L194.109 199.571L193.453 199.607L192.862 199.57C191.6 199.42 190.438 198.812 189.594 197.862C188.75 196.912 188.284 195.685 188.284 194.415C188.284 193.144 188.75 191.918 189.594 190.968C190.438 190.018 191.6 189.41 192.862 189.26L192.88 189.258L193.536 189.224ZM198.626 159.464L198.661 160.055L198.661 179.706L198.625 180.297C198.475 181.558 197.867 182.721 196.917 183.565C195.967 184.408 194.74 184.874 193.47 184.874C192.199 184.874 190.973 184.408 190.023 183.565C189.073 182.721 188.465 181.558 188.315 180.297L188.313 180.28L188.278 179.689L188.279 160.038L188.315 159.447C188.463 158.185 189.071 157.02 190.021 156.176C190.971 155.331 192.198 154.864 193.47 154.864C194.741 154.864 195.968 155.331 196.918 156.176C197.869 157.02 198.476 158.185 198.624 159.447L198.626 159.464ZM193.47 155.146C192.267 155.146 191.107 155.588 190.209 156.387C189.31 157.186 188.736 158.286 188.596 159.48L188.561 160.055V179.689L188.596 180.263C188.737 181.456 189.312 182.556 190.21 183.354C191.109 184.151 192.268 184.592 193.47 184.592C194.671 184.592 195.831 184.151 196.729 183.354C197.627 182.556 198.202 181.456 198.344 180.263L198.378 179.689V160.055L198.344 159.48C198.203 158.286 197.629 157.186 196.731 156.387C195.832 155.588 194.672 155.146 193.47 155.146ZM193.519 189.506L192.895 189.54C191.702 189.682 190.603 190.257 189.805 191.155C189.007 192.053 188.567 193.213 188.567 194.415C188.567 195.616 189.007 196.776 189.805 197.674C190.603 198.572 191.702 199.147 192.895 199.289L193.47 199.323L194.093 199.289C195.286 199.147 196.386 198.572 197.183 197.674C197.981 196.776 198.422 195.616 198.422 194.415C198.422 193.213 197.981 192.053 197.183 191.155C196.386 190.257 195.286 189.682 194.093 189.54L193.519 189.506Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1564_105130",
    x1: 38.8457,
    y1: 60.6182,
    x2: 207.651,
    y2: 170.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401042,
    stopColor: "#FEE1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677083,
    stopColor: "#FDADFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDE6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1564_105130",
    x1: 126.985,
    y1: 145.434,
    x2: 64.0381,
    y2: 158.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A554E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#FF00D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A554E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1564_105130",
    x1: 37.2236,
    y1: 91.6504,
    x2: 55.6481,
    y2: 155.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#FFF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677083,
    stopColor: "#FEE6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911458,
    stopColor: "#FEF1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1564_105130",
    x1: 153.946,
    y1: 228.802,
    x2: 241.235,
    y2: 182.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0902216,
    stopColor: "#FF00D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36BDF6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1564_105130"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.8457,
    y: 60.6182,
    width: 162.307,
    height: 119.615,
    rx: 24.4571,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardFail);
export default __webpack_public_path__ + "static/media/card_fail.c3ed990dc55afbde23c346220344e1ce.svg";
export { ForwardRef as ReactComponent };